export default __webpack_public_path__ + "static/media/circles.cb8d2675.png";